import { defineMessages } from 'react-intl';

export default defineMessages({
  surveyLimit: 'Active surveys/month',
  generalSurveyLimit: 'Active general surveys/month',
  feedbackLimit: 'Active feedbacks/month',
  targetedSurveyLimit: 'Active targeted surveys/month',
  cxSurveyLimit: 'Active CX surveys/year',
  customTheme: 'Custom survey theme',
  userSegmentLimit: 'Number of personal segments for each user',
  sharedSegmentLimit: 'Number of shared segments',
  matomoSegmentLimit: 'Number of segments synced to Matomo',
  matomoMonthlyVisitLimit: 'Number of monthly visits to Matomo',
  funnelLimit: 'Number of multi-dimensional funnels',
  tagComments: 'Categorize comments',
  userLimit: 'Number of users',
  advancedUserLimit: 'Number of advanced users',
  responseLimit: 'Responses/month',
  yearlyResponseLimit: 'Responses/year',
  generalSurveyTemplate: 'Template for general surveys',
  feedbackTemplate: 'Template for feedbacks',
  targetedSurveyTemplate: 'Template for targeted surveys',
  templateCustomerId: 'Customer ID for survey templates',
  globalBenchmarkCategoryId: 'Category ID for global benchmark',
  heatmapLimit: 'Number of heatmaps',
  heatmapSampleLimit: 'Number of heatmap samples',
  heatmapsDataRetentionDays: 'Heatmaps data retention in days',
  sessionRecordingLimit: 'Number of configured recordings',
  sessionRecordingSampleLimit: 'Number of recorded sessions',
  surveyVersionLimit: 'Number of versions',
  surveyLanguageLimit: 'Number of languages',
  customerOwnerRoleId: 'Customer owner role ID',
  customerAdvancedUserRoleId: 'Customer advanced user role ID',
  dataSourceOwnerRoleId: 'Data source owner role ID',
  dataSourceAdvancedUserRoleId: 'Data source advanced user role ID',
  dedicatedAnalyst: 'Dedicated analyst',
  unlimitedHeatmaps: 'Unlimited heatmaps and recordings',
  reportLimit: 'Number of reports',
  customCookiePrefix: 'Custom cookie prefix',
  disableCookies: 'Cookieless tracking',
  yearlyPrices: 'Yearly prices',
  monthlyPrices: 'Monthly prices',
  analytics: 'Analytics',
  monthlyPrice: 'Monthly price',
  monthlySinglePrice: 'Monthly single price',
  monthlyMultiplePrice: 'Monthly multiple price',
  prices: 'Prices',
  dataRetentionMonths: 'Data retention in months',
  dailyHeatmapSampleLimit: 'Heatmap samples/day',
  dailySessionRecordingLimit: 'Recorded sessions/day',
  actionLimit: 'Actions/month',
  visitLimit: 'Visits/month',
  hubspotProductId: 'Hubspot product ID',
  hubspotTrialProductId: 'Hubspot trial product ID',
  blockedDomains: 'Blocked domains',
  blockedEmailDomains: 'Blocked email domains',
  nextOrderNumber: 'Next order number',
  crashAnalytics: 'Crash analytics',
  formAnalytics: 'Form analytics',
  mediaAnalytics: 'Media analytics',
  eCommerceAnalytics: 'Ecommerce analytics',
  multiAttribution: 'Multi attribution',
  seoWebVitals: 'SEO web vitals',
  goalLimit: 'Number of goals',
  monthlyBrokenlinksCheckLimit: 'Broken links checks/month',
  brokenLinksWeeklyCheck: 'Check broken links weekly',
  brokenLinksMonthlyCheck: 'Check broken links monthly',
  advancedCampaignParameters: 'Advanced campaign parameters',
  expertCampaignParameters: 'Expert campaign parameters',
});
